
import { Browse } from "@/models/browse";
import { BrowseService } from "@/services/browse-service";
import { ViewService } from "@/services/view-service";
import AppBrowseList from "@/components/browse/BrowseListCard.vue";
import AppF3Settings from "@/views/settings/browse/F3Settings.vue";
import Vue from "vue";
import { UserConfigService } from "@/services/user-config-service";

export default Vue.extend({
	data() {
		return {
			browses: [] as Browse[],
			openModalInExternalTab: UserConfigService.getGeneralSettings().OpenModalInExternalTab,
			useCheckboxesInViews: UserConfigService.getGeneralSettings().UseCheckboxesInViews,
			compactView: UserConfigService.getGeneralSettings().CompactView,
			doubleClickOpensEdit: UserConfigService.getGeneralSettings().DoubleClickOpensEdit,
			productSearchSortOrder: UserConfigService.getGeneralSettings().ProductSearchSortOrder
		};
	},
	computed: {
		currentLang(): string {
			return this.$i18n.locale;
		},
		ignoredBrowseIds():number[] {
			return [18, 19];
		},
		shownBrowses():Browse[] {
			return this.browses.filter(b=>this.ignoredBrowseIds.indexOf(b.ID) == -1);
		},
		productSearchSortItems():{value:number, text:string}[] {
			return [
				{ value: 0, text: this.$ct("product-search-sort-sku").toString() },
				{ value: 1, text: this.$ct("product-search-sort-name-sku").toString() }
			];
		}
	},
	methods: {
		async restoreViews() {
			let confirm = await this.$wf.confirm(this.$ct("confirm-restore-views"),
				this.$t("common.yes").toString(), this.$t("common.no").toString(),
				this.$t("common.warning").toString(), "warning");

			if (confirm) {
				await ViewService.restoreViews();
				this.$wf.notify(this.$ct("restore-success"), "success", 3000, "check");
			}

		},
		onBrowseClick(browse:Browse){
			this.$router.push(`/settings/browse/${browse.ID}`);
		},
		async setUseCheckboxesInViews(val:boolean){
			let conf = UserConfigService.getGeneralSettings();
			conf.UseCheckboxesInViews = val;
			await UserConfigService.setGeneralSettings(conf);
		},
		async setOpenModalInExternalTab(val:boolean){
			let conf = UserConfigService.getGeneralSettings();
			conf.OpenModalInExternalTab = val;
			await UserConfigService.setGeneralSettings(conf);
		},
		async setCompactView(val:boolean){
			let conf = UserConfigService.getGeneralSettings();
			conf.CompactView = val;
			await UserConfigService.setGeneralSettings(conf);
		},
		async setDoubleClickOpensEdit(val:boolean){
			let conf = UserConfigService.getGeneralSettings();
			conf.DoubleClickOpensEdit = val;
			await UserConfigService.setGeneralSettings(conf);
		},
		async setProductSearchSortOrder(val:number){
			let conf = UserConfigService.getGeneralSettings();
			conf.ProductSearchSortOrder = val;
			await UserConfigService.setGeneralSettings(conf);
		}
	},
	async created() {
		this.browses = await BrowseService.getBrowses();
	},
	components: {
		AppBrowseList,
		AppF3Settings,
	},
	i18nEx: {
		componentPrefix: "components.settings"
	}
});
